import { FlowInsuranceCardBlockConfigSchema } from 'flow-schema';
import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const InsuranceCardBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.InsuranceCard),
  config: FlowInsuranceCardBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.InsuranceCard),
});
export type InsuranceCardBlock = z.infer<typeof InsuranceCardBlockSchema>;
